<template lang="pug">
div
  el-row
    divider(label="Dados do Processo")
  el-row(:gutter="20")
    el-col(:span="12" :lg="8").container-input
      app-label(label="Número do Processo:", :required="true")
      el-input.input(
        v-model="processo.numeroProcesso"
        :disabled="true"
      )
    el-col(:span="12" :lg="8").container-input
      app-label(label="Município:", :required="true")
      el-input.input(
        v-model="processo.cadastroColetivo.pecaTecnica.municipios[0].nome"
        :disabled="true"
      )
    el-col(:span="12" :lg="8").container-input
      app-label(label="Nome da Gleba:", :required="true")
      el-input.input.ellipsis(
        v-model="processo.cadastroColetivo.pecaTecnica.gleba"
        :disabled="true"
      )
    el-col(:span="12" :lg="8").container-input
      app-label(label="Área total:", :required="true")
      el-input.input(
        :disabled="true"
        :value="format(area, { prefix: '', suffix: ' ha', thousands: '.', decimal: ',', precision: 4 })"
      )

</template>

<script>
import Divider from '@/screens/arrecadacao/components/Divider'
import Utils from '@/utils/utils'
import AppLabel from '@/components/AppLabel'

export default {
  components: {
    Divider,
    AppLabel
  },

  props: {
    processo: {
      required: true,
      type: Object
    }
  },

  methods: {
    format: Utils.format
  },

  computed: {
    area () {
      return this.format(this.processo.cadastroColetivo.georreferenciamento.area, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
    }
  }
}
</script>

<style lang="scss">

.ellipsis {
  input {
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    overflow: hidden !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppDadosProcesso.vue